import { defineStore } from 'pinia';
import { ref } from 'vue';

import { ErrorMessage } from '@/messages/error';
import type { Priority } from '@/types/priority';
import { callApi } from '@/utils/api';
import { handleAxiosError } from '@/utils/error';

export const usePriorityStore = defineStore('priorities', () => {
    const priorities = ref<Priority[]>();

    async function get(): Promise<Priority[]> {
        if (priorities.value) return priorities.value;

        try {
            const result = await callApi({
                method: 'GET',
                endpoint: `priorities`
            });

            priorities.value = result.object as Priority[];
            return priorities.value;
        } catch (error) {
            return handleAxiosError(error, [], ErrorMessage.PRIORITIES_FETCH_FAILED);
        }
    }

    return {
        get
    };
});
